import { PERMISSIONS } from '../../constants';
import SystemUpdateIcon from '@mui/icons-material/SystemUpdate';
import list from './AppReleasesList';
import show from './AppReleasesShow';
import edit from './AppReleasesEdit';
import ComponentWithPermissions from '../ComponentWithPermissions';
import { UserRole } from '../../models';

export default {
  list,
  show,
  edit: new ComponentWithPermissions({ component: edit, permissions: [PERMISSIONS.ADMIN], userRoles: [UserRole.admin] }),
  name: 'app-releases',
  permissions: [PERMISSIONS.ADMIN],
  options: { label: 'Versões do app' },
  icon: SystemUpdateIcon,
};
